import ArrowTop from "assets/svg/arrow-top.svg";
import React from "react";

import useScrollPosition from "../../../src/hooks/useScrollPosition";

const Index = () => {
  const onClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const scrollYPosition = useScrollPosition();
  return (
    <>
      {scrollYPosition > 350 && (
        <div
          className="fixed bottom-[120px] left-[40px] z-50 flex h-[45px] w-[45px] cursor-pointer items-center justify-center rounded-full bg-[#FBCF32] md:left-[92px]"
          onClick={onClick}
        >
          <ArrowTop />
        </div>
      )}
    </>
  );
};

export default Index;
